$(document).ready(function(){
  $('.px-main-product__content-tab .accordion-list > li > .answer').hide();
  $('.px-main-product__content-tab:first .accordion-list > li > .answer').show();
    
  $('.px-main-product__content-tab .accordion-list > li').click(function(e) {
    if ($(this).hasClass("active")) {
        var target = $( e.target );
        if ( !target.is( "p" ) ) {
          $(this).removeClass("active").find(".answer").slideUp();
        }
    } else {
      $(".px-main-product__content-tab .accordion-list > li.active .answer").slideUp();
      $(".px-main-product__content-tab .accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });
}); 

$(document).ready(function(){
  $('.px-bottle-info__box > li > .answer').hide();
    
  $('.px-bottle-info__box > li').click(function(e) {
    if ($(this).hasClass("active")) {
      var target = $( e.target );
      if ( !target.is( "p" ) ) {
        $(this).removeClass("active").find(".answer").slideUp();
      }
    } else {
      $(".px-bottle-info__box > li.active .answer").slideUp();
      $(".px-bottle-info__box > li.active").removeClass("active");
      $(this).addClass("active").find(".answer").slideDown();
    }
    return false;
  });

  $('.slideshow a[href*="#"]').click(function(e) {
      // Your code here, for example, scroll to the target
      // For example, smooth scroll to the target element
     e.preventDefault();
      var target = $(this.hash);
      if (target.length) {
          $('html, body').animate({
              scrollTop: target.offset().top - 85
          }, 1000);
          return false;
      } 
  }); 

  $('.coupon-code-button').click(function() { 
    var textToCopy = $('#copycouponcode').text();
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val(textToCopy).select();
    document.execCommand("copy");
    tempInput.remove();
    var tooltip = $("<div>");
    tooltip.addClass("custom-tooltip");
    tooltip.text("Coupon Copied");
    $(this).after(tooltip);
    tooltip.fadeIn(200).delay(1500).fadeOut(200, function() {
      $(this).remove();
    });
  });  

  $(document).on('click','.qty_selector2 div[role="button"]',function(){
    var qty = $(this).data('qty');
    $(this).parents('.product-detail__form__action').find('input[name="quantity"]').val(qty); 
    $('.qty_selector2 div[role="button"]').removeClass('current-qty');
    $(this).addClass('current-qty');
  })

});


var swiper = new Swiper(".px-main-product__main-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});



$(".px-main-product-sticky-cart button").click(function(){
  $(".px-main-cart-button").click(); 
  return false;
});

 document.addEventListener('DOMContentLoaded', function () {
    var title = document.querySelector('.product-area__details__title');
    var trustedBadge = document.querySelector('.reviews7_wrapper');
    var addToCartButton = document.querySelector('.product-detail__form__action button');
    var price = document.querySelector('.price-area');
    var stickyButton = document.createElement('div');
    stickyButton.className = 'sticky-add-to-cart';

   /*
    // Combine the HTML content of each variable into the stickyButton
    stickyButton.innerHTML = `
      <div class="sticky-content">
        <div class="sticky-title">${title.innerHTML}</div>
        <div class="sticky-trusted-badge">${trustedBadge.innerHTML}</div>
        <div class="sticky-price">${price.innerHTML}</div>
        ${addToCartButton.outerHTML}
      </div>
    `;
    
    document.body.appendChild(stickyButton);
   */
    
    window.addEventListener('scroll', function () {
      var addToCartButtonRect = addToCartButton.getBoundingClientRect();
      var showStickyButton = addToCartButtonRect.top <= 0;
    
      if (showStickyButton) {
        stickyButton.style.display = 'block';
      } else {
        stickyButton.style.display = 'none';
      }
    });

    $('.sticky-content .button').click(function(e) {
      // Your code here, for example, scroll to the target
      // For example, smooth scroll to the target element
     e.preventDefault();
      var target = $('.product-purchase-form');
      if (target.length) {
          $('html, body').animate({
              scrollTop: target.offset().top - 85
          }, 1000);
          return false;
      }
  });


   $(document).on('click','.bundle_box_cart a.button',function(e){
      e.preventDefault();
     var id = $(this).data('id');
      console.log(id);
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:{quantity:1,id:id},
        success: function(data){
          $('.cart-icon--basket2')[0].click();}
      });
   })

  });

